import {
  StepItem,
  StepsProps
} from "../../../../../../shared/components/Steps";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces/identityVerificationRequest";
import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";
import { selectorIsReviewStrategyApproval } from "../../../../selectors/selectorIsReviewStrategyApproval";

type Props = {
  status: IdentityVerificationRequestStatus;
  isPendingSuccessStatus: boolean | undefined;
  reviewStrategy: RequirementReviewStrategy | undefined;
};

export const getIdentityVerificationPayerProgressSteps = ({
  status,
  isPendingSuccessStatus,
  reviewStrategy
}: Props): StepItem[] => {
  const isProcessedVisible = !selectorIsReviewStrategyApproval(reviewStrategy);

  const allStepsCombinations: Record<
    IdentityVerificationRequestStatus,
    StepsProps["steps"]
  > = {
    [IdentityVerificationRequestStatus.Complete]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ],
    [IdentityVerificationRequestStatus.Pending]: isPendingSuccessStatus
      ? [
          {
            title: "Start",
            status: "Complete"
          },
          {
            title: "Processed",
            status: "Active"
          },
          {
            title: "Complete",
            status: "Pending"
          }
        ]
      : [
          {
            title: "Start",
            status: "Active"
          },
          {
            title: "Processed",
            status: "Pending"
          },
          {
            title: "Complete",
            status: "Pending"
          }
        ],
    [IdentityVerificationRequestStatus.Failed]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Failed"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ]
  };

  return allStepsCombinations[status].filter(step =>
    step.title === "Processed" ? isProcessedVisible : true
  );
};
